import { object, preprocess } from 'zod';

import {
  awardCountLimitSchema,
  LimitDisabledSchemaWithIsEnabled,
  LimitSchema,
  TransactionLimitDisabledSchemaWithIsEnabled,
  TransactionLimitSchema,
  transactionFrequencyLimitSchema,
  validateMembershipAwardCountLimitsLessThanGlobal,
} from '@occc/feat-limits';
import { withIsEnabled } from '@occc/validation';

const AwardCountEnabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
  transaction: TransactionLimitSchema.optional(),
  transactionFrequency: transactionFrequencyLimitSchema,
  membershipAwardCountLimits: awardCountLimitSchema,
  globalAwardCountLimits: awardCountLimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipAwardCountLimitsLessThanGlobal({
    membership: data.membershipAwardCountLimits,
    global: data.globalAwardCountLimits,
    ctx,
  });
});

const AwardCountDisabledSchema = object({
  membership: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  global: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  transaction: preprocess(
    (value) => (value == null ? undefined : {}),
    TransactionLimitDisabledSchemaWithIsEnabled.optional(),
  ),
  transactionFrequency: preprocess(() => ({}), transactionFrequencyLimitSchema),
  membershipAwardCountLimits: preprocess(() => ({}), awardCountLimitSchema),
  globalAwardCountLimits: preprocess(() => ({}), awardCountLimitSchema),
});

export const AwardCountSchema = withIsEnabled(AwardCountEnabledSchema, AwardCountDisabledSchema);
